import { Button, Card, CardBody, CardFooter } from '@material-tailwind/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import SuccessAnimation from '../../animation/SuccessAnimation';

function PaymentFinish() {
    const navigate = useNavigate();
    return (
    <div className="w-full h-full flex justify-center my-5">
        <Card className="about-container" placeholder={""}>
          <CardBody placeholder={""}>
            <div className="about-header text-center mb-5">
                <h2 className="text-3xl font-semibold">Thanh toán</h2>
                <div className="underline"></div>
            </div>
            <div className="w-full flex justify-center mb-5">
                <SuccessAnimation className={"w-16 h-16"}/>
            </div>
            <div className="about-content text-center mb-5">
                <p className="text-2xl">Đặt hàng thành công</p>
            </div>
          </CardBody>
          <CardFooter className="pt-0 flex justify-center" placeholder={""}>
            <Button color="deep-orange" placeholder={""}
            onClick={() => navigate('/order') }>Xem đơn hàng</Button>
          </CardFooter>
        </Card>
    </div>
    );
}

export default PaymentFinish;
